"use strict";
import {http} from '../../core';
import Config from "../../app.config";
const RequestServiceBeta = http.create({ baseURL: Config.BASE_API_Once });
const RequestService = http.create();

export default {
    //获取班次列表
    schedulingList:function (param) {
        return RequestService.post("scheduling/list",param);
    },
    //删除班次
    delScheduling:function (param) {
        return RequestService.get("scheduling/del",param);
    },
    //新增班次
    addScheduling:function (param) {
        return RequestService.post("scheduling/add",param);
    },
    //修改班次信息
    updateScheduling:function (param) {
        return RequestService.post("scheduling/update",param);
    },
    //班次详细
    detailScheduling:function (param) {
        return RequestService.get("scheduling/detail",param);
    },
    //获取排班列表信息
    arrangementList:function (param) {
        return RequestService.post("arrangement/list",param);
    },
    //新增排班
    addArrangement:function (param) {
        return RequestService.post("arrangement/add",param);
    },
    //编辑排班
    updateArrangement:function (param) {
        return RequestService.post("arrangement/update",param);
    },
    //删除排班
    delArrangement:function (param) {
        return RequestService.get("arrangement/del",param);
    },
    //排班详细
    detailArrangement:function (param) {
        return RequestService.get("arrangement/detail",param);
    },
    //调班
    replaceArrangement:function (param) {
        return RequestService.post("arrangement/replace",param);
    },
    //排班日历
    arrangementCanlendar:function (param) {
        return RequestService.get("arrangement/mycanlendar",param);
    },
}